import React ,{Component } from 'react';
import CertReqReport from '../views/certreqreport';
import { certrequestActions } from "../../actions";
import { connect } from 'react-redux';

import { withRouter } from "react-router-dom";

class CertReqReportContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
        this.addcertificateprint=this.addcertificateprint.bind(this);
    }
    
    addcertificateprint(id)
    {
        const { dispatch } = this.props;  
        dispatch(certrequestActions.addcertificateprint(id)) 
    }

    componentDidMount(){

        const {certreqId}=this.props.match.params;

        console.log('Props',this.props);
 
        const { dispatch } = this.props;   
 
         if (certreqId) {
 
             let id = certreqId;
              
             dispatch(certrequestActions.get(id));     
         
         } 

    }

    render() { 

        const { type,obj,items } = this.props;


        return ( 
            <CertReqReport addcertificateprint={this.addcertificateprint} model={(obj!=null && obj.CertReq!=null)?obj.CertReq:null} ref="child"  {...this.props}   />
         );
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items } = state.objs;
    
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items
       
             
    };
} 

export default withRouter(connect(mapStateToProps)(CertReqReportContainer));